import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FavoritesService } from '../_services/favorites.service';

@Component({
  selector: 'app-compound-card',
  templateUrl: './compound-card.component.html',
  styleUrls: ['./compound-card.component.scss']
})
export class CompoundCardComponent {
  @Input() element: any;

  constructor(public favoritesService: FavoritesService) {}

  ngOnInit() {}

  toggleFavorite(event: Event): void {
    event.stopPropagation();
    if (!this.element) { return; }
    const id = this.element.id ? this.element.id.split('/').pop() : '';
    const label = this.element.main_label || '';
    this.favoritesService.toggle(id, label);
  }

  get compoundId(): string {
    return this.element && this.element.id ? this.element.id.split('/').pop() : '';
  }
}
